import { gql } from "@apollo/client";

export const APPLY_FRAMEWORK = gql`
  mutation ApplyFramework($input: ComplianceFrameworkMutationInput!) {
    applyFrameworkMutation(input: $input)
  }
`;
